import { AbsoluteReturn, AbsoluteReturnTimeWindow } from './AbsoluteReturn';
import { AssetWeighted, AssetWeightedTimeWindow } from './AssetWeighted';
import { CompositeReturn, CompositeReturnTimeWindow } from './CompositeReturn';
import { StaticWeighted, StaticWeightedTimeWindow } from './StaticWeighted';
import { CompositeWeighted, CompositeWeightedTimeWindow } from './CompositeWeighted';
import { PullForward, PullForwardTimeWindow } from './PullForward';

export type Benchmark =
  | AbsoluteReturn
  | CompositeReturn
  | PullForward
  | StaticWeighted
  | CompositeWeighted
  | AssetWeighted;
export type TimeWindow =
  | AbsoluteReturnTimeWindow
  | CompositeReturnTimeWindow
  | PullForwardTimeWindow
  | StaticWeightedTimeWindow
  | CompositeWeightedTimeWindow
  | AssetWeightedTimeWindow
  | undefined;

export interface BenchmarkType {
  id: number;
  name: string;
}

export interface CalculationFrequency {
  id: number;
  name: string;
}

export interface RebalanceFrequency {
  typeId: number;
  name: string;
  customMonths?: any;
}

export interface WeightingMethodology {
  id: number;
  name: string;
}

export enum TabOptions {
  Benchmarks = 'Benchmarks',
  CalculationTrace = 'Calculation Trace',
  UploadFiles = 'Upload',
  Admin = 'Admin',
  PullForward = 'pull-forward',
}

export enum BenchmarkTypes {
  AbsoluteReturn = 1,
  AssetWeighted = 2,
  CompositeReturn = 3,
  PullForward = 4,
  CompositeWeighted = 5,
  StaticWeighted = 6,
}

export type SelectorType = {
  label: string;
  value: string | number;
};

export type FunctionOnChangeType = (event: {
  target: { value: string };
}) => void;

export type FunctionOnFromDateChangeType = (
  date: Date | [Date | null, Date | null] | null,
  event: React.SyntheticEvent<any> | undefined
) => void;

export type PortfolioAnalyticsCalendar = {
  id: number,
  name: string
}